<div class="container" *transloco="let t; prefix: 'core.pageNotFound'">
  <div class="lang">
    <app-language-switcher variant="primary" />
  </div>
  <div class="content">
    <h1>{{ t('title') }}</h1>
    <p>{{ t('message') }}</p>
    <button mat-raised-button color="primary" routerLink="/">{{ t('goHome') }}</button>
  </div>
</div>
